import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"radio-2"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 4V18C15.3333 18 8.66667 18 2 18L2 4L22 4Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M18 11C18 12.6569 16.6569 14 15 14C13.3431 14 12 12.6569 12 11C12 9.34315 13.3431 8 15 8C16.6569 8 18 9.34315 18 11Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M6 18V21M18 18V21M22 4V18C15.3333 18 8.66667 18 2 18L2 4L22 4Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M6 9H8M6 13H8M18 11C18 12.6569 16.6569 14 15 14C13.3431 14 12 12.6569 12 11C12 9.34315 13.3431 8 15 8C16.6569 8 18 9.34315 18 11Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Radio2 = Vue.extend<IconProps>({
  name: 'Radio2Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'radio-2',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Radio2;
